import BostonGeneText from "./bostongene/BostonGeneText.jsx";
import SberTechText from "./sbertech/SberTechText.jsx";
import GosNIIASText from "./gosniias/GosNIIASText.jsx";
import RASText from "./ras/RASText.jsx";

const Work = ({ position = [0, 0, 0] }) => {
  return (
    <group position={position}>
      <BostonGeneText position={[20, 0, 0]} />
      <SberTechText position={[45, 0, 0]} />
      <GosNIIASText position={[68, 0, 0]} />
      <RASText position={[90, 0, 0]} />
    </group>
  );
};

export default Work;
